export default __webpack_public_path__ + "static/media/master.a643c9ae.svg";